import { Col, Form, List, Radio, Row, Typography } from "antd";
import React from "react";
import { orientationFieldsOptions } from "../../../../Options/physioOptions";
import { DislikeOutlined, LikeOutlined } from "@ant-design/icons";

const Orientation = ({ psych = false, setOrientation }) => {
  const handleChange = (value, fieldValue) => {
    setOrientation((prev) => ({
      ...prev,
      [fieldValue]: value,
    }));
  };
  return (
    <>
      <List
        bordered={false}
        className="moca-section-card moca-memory-list"
        style={{
  width: "100%",
  maxWidth: psych ? "100%" : "600px",
  margin: "0 auto",
  padding: "20px",
}}
        dataSource={orientationFieldsOptions}
        renderItem={(field) => (
          <List.Item>
            <Row style={{ width: "100%" }} align="middle" gutter={[8, 8]}>
              <Col xs={24} md={12}>
                <Typography>{field.label}</Typography>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  key={field.value}
                  name={
                    psych === true
                      ? ["moca", "orientation_data", field.value]
                      : ["orientation_data", field.value]
                  }
                >
                  <Radio.Group
                    style={{ width: "100%" }}
                    onChange={(e) =>
                      handleChange(e?.target?.value, field.value)
                    }
                  >
                    <Row justify="space-around" align={"middle"}>
                      <Col>
                        <Radio.Button value={"yes"} className="like-btn">
                          <LikeOutlined />
                        </Radio.Button>
                      </Col>
                      <Col>
                        <Radio.Button value={"no"} className="dislike-btn">
                          <DislikeOutlined />
                        </Radio.Button>
                      </Col>
                    </Row>
                  </Radio.Group>
                </Form.Item>
              </Col>
            </Row>
          </List.Item>
        )}
      />
    </>
  );
};

export default Orientation;
